import { useState } from 'react';
import smartcrop from 'smartcrop';
import { CropRect } from './types';

type UseCropReturn = {
  detectCrop: (image: HTMLImageElement) => Promise<CropRect | undefined>;
  isDetecting: boolean;
};

export const useCrop = (): UseCropReturn => {
  const [isDetecting, setIsDetecting] = useState(false);

  const detectCrop = async (image: HTMLImageElement): Promise<CropRect | undefined> => {
    setIsDetecting(true);
    try {
      const aspectRatio = image.naturalWidth / image.naturalHeight;
      const cropWidth = Math.round(image.naturalWidth * 0.8);
      const cropHeight = Math.round(cropWidth / aspectRatio);

      const result = await smartcrop.crop(image, {
        width: cropWidth,
        height: cropHeight,
      });

      return result.topCrop;
    } catch {
      return undefined;
    } finally {
      setIsDetecting(false);
    }
  };

  return { detectCrop, isDetecting };
};
